<div *ngIf="isLoading" class="se-loader"></div>
<div class=" taw-stats">
  <!-- Widgets -->
  <div class="row mx-0 mt-1 mb-1">

    <!-- Device Count -->
    <div class="col p-1">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1">{{ labels.statDeviceCountTitle|translate }}</span>
        </div>
        <div class="card-body h-100">
          <div class="row align-items-center h-100">
            <div class="col-12 text-center">
              <div *ngIf="this.deviceCountWLoader" class="se-loader se-loader-widget"></div>
              <span class="primary-bold-text">{{ deviceCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Device Status -->
    <div class="col p-1">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1">{{ labels.statDeviceStatusCountTitle|translate }}</span>
        </div>
        <div class="card-body h-100">
          <div class="row align-items-center h-100">
            <div class="col-8">

              <div class="form-ele">
                <select aria-label="deviceStatusCount" class="se-form-control mw-auto" [(ngModel)]="selectedDeviceStatus" (change)="DeviceStatusCountChange($event)">
                  <option *ngFor="let item of deviceStatusData; let i = index" [ngValue]="item.key">{{item.value|translate}}</option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div *ngIf="this.deviceCountStatusWLoader" class="se-loader se-loader-widget"></div>
              <div style="display:inline-block">
                <span class="primary-bold-text" title="{{deviceStatusTitle}}" [ngClass]="selectedDeviceStatus!=2?(selectedDeviceStatus == 1 ? 'text-success' : 'text-danger'):''">
                  {{ deviceStatusCount }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Group Count -->
    <div class="col p-1">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1">{{ labels.statGroupCountTitle|translate }}</span>
        </div>
        <div class="card-body h-100">
          <div class="row align-items-center h-100">
            <div class="col-12 text-center">
              <div *ngIf="this.groupCountWLoader" class="se-loader se-loader-widget"></div>
              <span class="primary-bold-text text-default cursorPointerHand" (click)="GroupDetails()"
                    (keypress)="GroupDetails()"
                    (keydown)="GroupDetails()"
                    (keyup)="GroupDetails()">{{deviceGroupCount}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Device By Group -->
    <div class="col p-1">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1">{{ labels.statDeviceByGroupTitle|translate }}</span>
        </div>
        <div class="card-body h-100">
          <div class="row align-items-center h-100">
            <div class="form-ele">
              <p-multiSelect class="se-form-control mw-auto drpcntrls" (onChange)="DeviceByGroupCountChange($event)" display="chip"
                             [options]="deviceGroupNames" [(ngModel)]="selectedDeviceGroup" placeholder="Select Device Group" optionLabel="name"></p-multiSelect>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Device by controller model-->
    <div class="col p-1">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1">{{this.labels.deviceByControllerModel|translate}}</span>
        </div>
        <div class="card-body h-100">
          <div class="row align-items-center h-100">
            <div class="form-ele width100per">
              <p-multiSelect class="se-form-control mw-auto drpcntrls" (onChange)="ControllerTypeByGroupsChange($event)" [options]="contrlModels" [(ngModel)]="selectedcontrlModel" placeholder="Select Controller Model" optionLabel="name" display="chip"></p-multiSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Charts -->
  <div class="row mx-0 mt-1 mb-1 ">
    <!-- Device Alarms by status -->
    <div class="col p-1">
      <div class="card h-100">
        <div class="card-header p-1 row">
          <div class="col"> {{this.labels.alarmCountGroupByDeviceStatus|translate}}</div>
          <div class="text-right col">
            <img class="bar-download download-icon ml-1 mb-2" width="150px" height="150px" src="assets/download.svg" title="Download" alt="Download" (click)="columnChart.exportChartLocal()"
                 (keypress)="columnChart.exportChartLocal()"
                 (keydown)="columnChart.exportChartLocal()"
                 (keyup)="columnChart.exportChartLocal()" />
            <img class=" full-screen-icon ml-1" title="View in fullScreen" (click)="columnChart.fullscreen.open()"
                 (keypress)="columnChart.fullscreen.open()"
                 (keydown)="columnChart.fullscreen.open()"
                 (keyup)="columnChart.fullscreen.open()"
                 src="assets/fullscreen.svg" width="150px" height="150px" alt="fullscreen"/>

          </div>
        </div>
        <div class="card-body p-0">
          <div class="col">
            <div class="col-2 pt-3">
              <div class="form-ele">
                <select aria-label="dateRange" class="se-form-control mw-auto" [(ngModel)]="colChrtslctedDtRng" (change)="colChrtslctedDtRngChange($event)">
                  <option *ngFor="let item of colChrtDtRng; let i = index" [ngValue]="item.key">{{item.value|translate}}</option>
                </select>
              </div>
            </div>
            <div class="col pt-3">
              <div id="bar" [chart]="columnChart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-0 mt-1 mb-1 ">
    <!-- alarm By status -->
    <div class="col p-1 halfWidth">
      <div class="card h-100">
        <div class="card-header p-1 row">
          <div class="col">
            {{this.labels.alarmCountByStatus|translate}}
          </div>
          <div class="text-right col">
            <img class="download-icon ml-1 mb-2" width="150px" height="150px" src="assets/download.svg" alt="Download" title="Download"
                 (click)="pieChart.exportChartLocal()"
                 (keypress)="pieChart.exportChartLocal()"
                 (keydown)="pieChart.exportChartLocal()"
                 (keyup)="pieChart.exportChartLocal()" />
            <img class=" full-screen-icon ml-1" title="View in fullScreen"
                 (click)="pieChart.fullscreen.open()"
                 (keypress)="pieChart.fullscreen.open()"
                 (keydown)="pieChart.fullscreen.open()"
                 (keyup)="pieChart.fullscreen.open()" width="150px" height="150px" alt="fullscreen" src="assets/fullscreen.svg" />

          </div>
        </div>
        <div class="card-body p-0">
          <div class="col">
            <div class="col-4  pt-3">
              <div class="form-ele">
                <select aria-label="dateRange" class="se-form-control mw-auto" [(ngModel)]="pieChrtslctedDtRng" (change)="pieChrtslctedDtRngChange($event)">
                  <option *ngFor="let item of colChrtDtRng; let i = index" [ngValue]="item.key">{{item.value|translate}}</option>
                </select>
              </div>
            </div>
            <div class="col pt-3 text-center">
              <div id="pie" [chart]="pieChart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--alarm distribution by time-->
    <div class="col p-1 halfWidth">
      <div class="card h-100">
        <div class="card-header p-1 row">
          <div class="col">
            {{this.labels.alarmCountDistributionOverTime|translate}}
          </div>
          <div class="text-right col">
            <img class="download-icon ml-1 mb-2" width="150px" height="150px" src="assets/download.svg" alt="Download" title="Download"
                 (keypress)="distributionChart.exportChartLocal()"
                 (keydown)="distributionChart.exportChartLocal()"
                 (keyup)="distributionChart.exportChartLocal()"
                 (click)="distributionChart.exportChartLocal()" />
            <img class=" full-screen-icon ml-1" alt="View in fullScreen"
                 (keypress)="distributionChart.fullscreen.open()"
                 (keydown)="distributionChart.fullscreen.open()"
                 (keyup)="distributionChart.fullscreen.open()"
                 (click)="distributionChart.fullscreen.open()"
                 width="150px" height="150px" src="assets/fullscreen.svg" />

          </div>
        </div>
        <div class="card-body p-0">
          <div class="col">
            <div class="col-4  pt-3">
              <div class="form-ele">
                <select aria-label="dateRange" class="se-form-control mw-auto" [(ngModel)]="distChrtslctedDtRng" (change)="distChrtslctedDtRngChange($event)">
                  <option *ngFor="let item of distriChrtDtRng; let i = index" [ngValue]="item.key">{{item.value|translate}}</option>
                </select>
              </div>
            </div>
            <div class="col pt-3 text-center">
              <div id="alarmDistribution" [chart]="distributionChart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-0 mt-1 mb-3">
    <!-- Alarms By Device By Timeframe -->
    <div class="col p-1">
      <div class="card h-100">
        <div class="card-header p-1 row">
          <div class="col">
            {{this.labels.alarmStatusCountOverTime|translate}}
          </div>
          <div class="text-right col">
            <img class="bar-download download-icon ml-1 mb-2" width="150px" height="150px" src="assets/download.svg" alt="Download" title="Download"
                 (keypress)="stockChart.exportChartLocal()"
                 (keydown)="stockChart.exportChartLocal()"
                 (keyup)="stockChart.exportChartLocal()"
                 (click)="stockChart.exportChartLocal()" />
            <img class=" full-screen-icon ml-1" title="View in fullScreen"
                 (keypress)="stockChart.fullscreen.open()"
                 (keydown)="stockChart.fullscreen.open()"
                 (keyup)="stockChart.fullscreen.open()"
                 (click)="stockChart.fullscreen.open()" width="150px" height="150px" alt="fullscreen" src="assets/fullscreen.svg" />
          </div>
        </div>
        <div class="card-body p-0">
          <div class="row">
            <div class="col">
              <div id="stock" [chart]="stockChart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Alarm Info Modal -->
<div class="se-dialog full-page-dialog" *ngIf="showInfoDialog">

  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">
        <button type="button" title="back" class="back" (click)="CloseModal()">
          <em class="fa fa-chevron-left"></em>
        </button>
        <span>{{ labels.alarmInfo | translate}}</span>
        <button type="button" title="close" class="close" (click)="CloseModal()">
          <em class="fa fa-times"></em>
        </button>
      </h3>
    </div>

    <div class="se-dialog-body">
      <div *ngIf="isDialogLoading" class="se-loader"></div>
      <div class="col-12 pt-3">
        <div *ngIf="colChartClick">{{this.labels.dgTblHeaderDeviceName}}: {{SelectedDeviceName}}</div>
        <div class="ml-1" *ngIf="pieChartClick">{{this.labels.tableHeaderAlarmType}}: {{SelectedSeverityName}}</div>
        <div *ngIf="stockChartClick">{{this.labels.date}}: {{selectedStockChartDate}}</div>
      </div>
      <div class="col-12 pt-3">
        <p-table #dt [columns]="deviceAlarmCols" [value]="alarmsData" [paginator]="isPagination" [rows]="10" responsiveLayout="stack"
                 dataKey="alarmId" [autoLayout]="true">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" class="emptyHeader"></th>
              <th scope="col" *ngFor="let col of deviceAlarmCols" [pSortableColumn]="col.field" [ngStyle]="{'display': col.display}">
                <span *ngIf="col.field !== 'isActive'">
                  {{col.header | translate}}
                </span>
                <span *ngIf="col.field === 'isActive'">
                  {{ labels.alarmStatus|translate }}
                </span>

                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="deviceAlarmCols">
            <tr class="rowHeight" [pSelectableRow]="rowData">
              <td>
                <img alt="Critical Alarm" *ngIf="rowData.isActive==true && rowData.severity=='1'" width="15px" height="14px" src="assets/alarmSeverity2.svg" />
                <img alt="Warning Alarm" *ngIf="rowData.isActive==true && rowData.severity=='2'" width="15px" height="14px" src="assets/alarmSeverity1.svg" />
                <img alt="Inactive Alarm" *ngIf="rowData.isActive==false" width="14px" height="14px" src="assets/alarm-Inactive.svg" />
              </td>
              <td *ngFor="let col of deviceAlarmCols" [ngStyle]="{'display': col.display}">
                <span *ngIf="col.field !== 'isActive' && col.field !== 'startedOn' && col.field !== 'endedOn' && col.field !== 'severity'">
                  {{rowData[col.field]}}
                </span>
                <span *ngIf="col.field === 'isActive'">
                  {{ rowData[col.field] === true ? labels.tableDataDeviceActive : labels.tableDataDeviceInActive }}
                </span>
                <span *ngIf="col.field === 'startedOn'">
                  {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
                </span>
                <span *ngIf="col.field === 'endedOn'">
                  {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
                </span>

              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage" let-columns>
            <tr *ngIf="noDataAlarmInfo">
              <td [attr.colspan]="deviceAlarmCols.length+1">
                {{labels.noRecords | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<!-- group details Info Modal -->
<div class="se-dialog full-page-dialog" *ngIf="showGroupDeviceInfoDialog">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">
        <button type="button" title="back" class="back" (click)="CloseModal()">
          <em class="fa fa-chevron-left"></em>
        </button>
        <span>{{ labels.dgGroupInfoModalHeader | translate}}</span>
        <button type="button" title="close" class="close" (click)="CloseModal()">
          <em class="fa fa-times"></em>
        </button>
      </h3>
    </div>

    <div class="se-dialog-body">
      <div *ngIf="isGroupModalLoading" class="se-loader"></div>
      <div class="col-12 pt-3">
        <p-table #dt [columns]="deviceGroupCols" dataKey="id" [resizableColumns]="true" rowExpandMode="single" [autoLayout]="true" [value]="GroupDetailsList" [paginator]="isGroupPagination" [rows]="10">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" *ngFor="let col of deviceGroupCols" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.field === 'deviceIds'" [ngStyle]="{'width': col.width, 'display': col.display }">
                <span>
                  {{col.header | translate}}
                </span>
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <th scope="col"> </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="deviceGroupCols">
            <tr>
              <td *ngFor="let col of deviceGroupCols" [ngStyle]="{'width': col.width, 'display': col.display }">
                <span *ngIf="col.field !=='addedOn' ">
                  {{rowData[col.field]}}
                </span>
                <span *ngIf="col.field ==='addedOn'">
                  {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
                </span>
              </td>
              <td>
                <span>
                  <button type="button" pButton [pRowToggler]="rowData" (click)="GetDeviceByGroup(rowData.id)"
                          [icon]="expanded ? 'p-button-icon pi pi-chevron-up' : 'p-button-icon pi pi-chevron-down'"></button>
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
            <tr>
              <td [attr.colspan]="columns.length+1">
                <p-table [columns]="deviceCols" [value]="coolersData" [paginator]="isDeviceGroupPagination" [rows]="10">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th scope="col" *ngFor="let col of deviceCols" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width, 'display': col.display }">
                        {{ col.header | translate }}
                        <p-sortIcon [field]="col.field" *ngIf="col.field !== 'alarm_Severity' && col.header!=='#'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                      </th>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-coolersData let-columns="columns" let-i="rowIndex">
                    <tr class="heigt2-9em" [ngClass]="{selected_Row: rindex == i}">
                      <td *ngFor="let col of columns" class="overflow-control" title="{{coolersData[col.field]}}" [ngStyle]="{'display': col.display}">
                        <span *ngIf="col.header=='#'">
                          {{i+1}}
                        </span>
                        <span class="txtwordwrap" *ngIf="col.field =='name'">
                          {{coolersData[col.field]}}
                        </span>
                        <span *ngIf="col.field ==='lastConnectedOn'">
                          {{coolersData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
                        </span>
                        <span *ngIf="col.field === 'deviceStatus'">
                          {{ coolersData[col.field] === 0 ? labels.offline :(coolersData[col.field] === 1? labels.online :labels.tableDataDeviceInActive)}}
                        </span>

                      </td>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr *ngIf="noData">
                      <td [attr.colspan]="columns.length+3">
                        {{labels.noRecords | translate}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr *ngIf="noDataDeviceGroupGridInfo">
              <td [attr.colspan]="deviceGroupCols.length+1">
                {{labels.noRecords | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

